const carouselOptions = {
  loop: false,
  margin: 10,
  responsiveClass: true,
  lazyLoad: true,
  nav: false,
  autoplay: false,
  items: 1,
  dots: true,
  //dotsContainer: '.dots-container',
};

export const owlCarousel = {
  /**
   * Initiates the product carousel
   * @param  {element} el
   */
  bind: (el, binding) => {
    let owl;
    const $el = $(el);
    const options = Object.assign({}, carouselOptions, binding.value);

    setTimeout(() => {
      owl = $el.owlCarousel(options);
    }, 0);

    const data = binding.def.data;

    /**
     * Bind image preview
     * Only bind it when the carousel is a product carousel
     */
    if ($el.hasClass('product-carousel')) {
      $('body').on('click', '.owl-preview-image', (event) => {
        data.imagePreviewClick(event, owl);
      });
    }
  },
  data: {
    /**
     * Image preview callback
     */
    imagePreviewClick: (event, owl) => {
      /**
       * Get the current item and move the slider to that position
       */
      const imageToShow = $(event.target).attr('data-ref');
      owl.trigger('to.owl.carousel', [imageToShow]);
    },
  },
};
